import RegularButton from "components/CustomButtons/Button";
import EditIcon from '@material-ui/icons/Edit';
import React, { useState } from "react";
import { blue } from "@material-ui/core/colors";
import { ModalV2 } from "components/Modal/ModalV2";
import { TaxiForm } from "./TaxiForm";
import { useToggle } from "hooks/useToggle";
import { useDispatch, useSelector } from "react-redux";
import { getCustomerTaxiInfo } from "redux/actions/taxis/taxisActions";
import { extractIDs } from "helpers/extractIDs";
import { LoadingComponent } from "components/Loading/LoadingComponent";

export const columns = [
    {
        Header: "Placas",
        accessor: "plates",
        filterable: true,
        filterMethod: (filter, row) => {
            return row.plates.toLowerCase().includes(filter.value.toLowerCase());
        }
    },
    {
        Header: "Km/Ingreso",
        accessor: "initialMileage",
        filterable: true,
        filterMethod: (filter, row) => {
            return row.initialMileage.toLowerCase().includes(filter.value.toLowerCase());
        }
    },
    {
        Header: "Plantas",
        accessor: "stationLabel",
        filterable: true,
        filterMethod: (filter, row) => {
            return row.stationLabel.toLowerCase().includes(filter.value.toLowerCase());
        }
    },
    {
        Header: "NFC-T",
        accessor: "labelTag",
        filterable: true,
        filterMethod: (filter, row) => {
            return row.labelTag.toLowerCase().includes(filter.value.toLowerCase());
        }
    },
    {
        Header: "Fecha Registro",
        accessor: "registrationDate",
        filterable: true,
        filterMethod: (filter, row) => {
            return row.registrationDate.toLowerCase().includes(filter.value.toLowerCase());
        }
    },
    {
        Header: "Acciones",
        Cell: ({ original }) => {
            const dispatch = useDispatch()
            const { units } = useSelector(({ unitsReducer }) => unitsReducer)
            const { stations, companies } = useSelector(({ companies }) => companies)
            const { isLoadingComp } = useSelector(({ search }) => search)
            const [open, setOpen] = useToggle()
            const [data, setData] = useState({})

            const handleCustomer = async () => {
                const stationsIDs = extractIDs(original.stations, 'idStation', true)
                const unitsIDs = extractIDs(original.stations, 'idUnit', true)
                const stationsSelected = stationsIDs.map(id => {
                    const station = stations[id]
                    const companyName = companies[station.id_company].name
                    return {
                        ...station,
                        label2: `${companyName} - ${station.label}`
                    }
                })
                const unitsSelected = unitsIDs.map(id => {
                    const unit = units[id]
                    return stationsIDs.includes(unit.idStation) && unit.type === "ESTACION" && unit
                })
                setData({...original})
                // dispatch(getNfcTagsByStatus())
                dispatch(getCustomerTaxiInfo(original, stationsSelected, unitsSelected, companies, stations, units, setOpen, setData))
            }
            return (
                <div style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: 4
                }}>
                    <RegularButton
                        round justIcon
                        color="transparent"
                        onClick={handleCustomer}
                    >
                        <EditIcon style={{ color: blue[300] }} />
                    </RegularButton>
                    <ModalV2
                        open={open}
                        onClose={setOpen}
                        title="Editar flotilla"
                    >
                        {
                            isLoadingComp.loadingTaxiCustomer
                                ? <LoadingComponent />
                                :
                                <TaxiForm onClose={setOpen} isEdit data={data}/>
                        }
                    </ModalV2>
                </div>
            )
        }
    }]